/* ==========================================================================
   Song video — click to play facade
   Added 2026-10-02.

   A YouTube or Vimeo embed pulls down roughly a megabyte of player and sets
   third party cookies on every visitor who scrolls past it, watched or not.
   This waits for an actual press, then swaps the poster for the iframe with
   autoplay on, so the visitor gets the video they asked for in one click.

   No library, no polling, nothing registered on scroll.
   ========================================================================== */

(function () {
  'use strict';

  if (window.LK && window.LK.__videoInit) return;
  window.LK = window.LK || {};
  window.LK.__videoInit = true;

  /* Turn a watch page URL into an embed URL. Returns null for anything we do
     not recognise, so a mistyped link shows the poster rather than an error. */
  function embedUrl(raw) {
    var url;
    try {
      url = new URL(raw, window.location.href);
    } catch (e) {
      return null;
    }

    var host = url.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      var short = url.pathname.slice(1);
      return short ? 'https://www.youtube-nocookie.com/embed/' + short + '?autoplay=1&rel=0' : null;
    }

    if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      var id = url.searchParams.get('v');
      if (!id && url.pathname.indexOf('/embed/') === 0) id = url.pathname.split('/embed/')[1];
      if (!id && url.pathname.indexOf('/shorts/') === 0) id = url.pathname.split('/shorts/')[1];
      return id ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0' : null;
    }

    if (host === 'vimeo.com' || host === 'player.vimeo.com') {
      var vid = url.pathname.split('/').filter(Boolean).pop();
      return /^\d+$/.test(vid) ? 'https://player.vimeo.com/video/' + vid + '?autoplay=1' : null;
    }

    return null;
  }

  function play(facade) {
    var src = embedUrl(facade.getAttribute('data-video-url') || '');
    if (!src) return;

    var frame = document.createElement('iframe');
    frame.className = 'lk-video__player';
    frame.src = src;
    frame.title = facade.getAttribute('data-title') || 'Video';
    frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'lazy');

    facade.replaceChildren(frame);
    facade.classList.add('is-playing');

    /* Move focus into the player so a keyboard user lands on the controls
       rather than back at the top of the document. */
    frame.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.lk-video__play');
    if (!button) return;
    var facade = button.closest('[data-lk-video-facade]');
    if (facade) play(facade);
  });
})();
